import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, Table, TableBody, TableCell, TableRow, TableHead, TextField, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

export default function ProgressTrackingDialog({ open, onClose, onSave, getColumnInfo, getLastDocument, windcontract_id }) {
    const [columnInfo, setColumnInfo] = useState([]);
    const [formData, setFormData] = useState({});

    // 取得所有欄位資訊
    useEffect(() => {
        if (open) {
            getColumnInfo().then((result) => {
                setColumnInfo(result || []);
                const initialData = {};
                result.forEach((section) => {
                    section.columns.forEach((col) => {
                        initialData[`${col.id}_achievement`] = col?.achievement_status_plan_content || "";
                        initialData[`${col.id}_implementation`] = col?.implementation_progress_content || "";
                    });
                });
                setFormData(initialData);
            });
        }
    }, [open, getColumnInfo]);

    // 新增的函式：處理載入上次文件內容
    const handleLoadLastDocument = async () => {
        try {
            const lastDocument = await getLastDocument({ windcontract_id });

            // Normalize to an array of sections
            const sections = Array.isArray(lastDocument?.data)
                ? lastDocument.data
                : Array.isArray(lastDocument)
                    ? lastDocument
                    : [];

            if (!sections.length) {
                alert("找不到上次的文件內容。");
                return;
            }

            // Build a quick lookup of valid column IDs from current schema
            const validIds = new Set(
                (columnInfo || []).flatMap((sec) => (sec.columns || []).map((c) => c.id))
            );

            const newFormData = { ...formData };
            sections.forEach((section) => {
                (section.columns || []).forEach((column) => {
                    if (validIds.has(column.id)) {
                        newFormData[`${column.id}_achievement`] =
                            column?.achievement_status_plan_content ?? "";
                        newFormData[`${column.id}_implementation`] =
                            column?.implementation_progress_content ?? "";
                    }
                });
            });

            setFormData(newFormData);
            alert("已載入上次文件內容！");
        } catch (e) {
            console.error("載入上次文件內容失敗", e);
            alert("載入上次文件內容失敗，請稍後再試。");
        }
    };

    const handleSave = (status) => {
        const data = (columnInfo || []).map((section) => ({
            ...section,
            columns: (section.columns || []).map((col) => ({
                ...col,
                achievement_status_plan_content: formData[`${col.id}_achievement`] ?? "",
                implementation_progress_content: formData[`${col.id}_implementation`] ?? "",
            })),
        }));

        onSave({ status, data, sheetId: "" });
    };

    return (
        <Dialog
            open={open}
            disableEscapeKeyDown
            keepMounted
            disableRestoreFocus
            onClose={(event, reason) => {
                if (reason === "backdropClick" || reason === "escapeKeyDown") {
                    return;
                }
                onClose();
            }}
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle>
                新增工作進度
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    style={{ position: "absolute", right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {/* 載入上次文件按鈕 */}
                <Box mb={2} display="flex" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: "#cae3e8",
                            color: "#000",
                            fontWeight: "bold",
                        }}
                        onClick={handleLoadLastDocument}
                    >
                        載入上次文件內容
                    </Button>
                </Box>
                {/* 表單內容 */}
                {columnInfo.map((section) => (
                    <Box key={section.id} mb={3} border={1} borderColor="#ddd" borderRadius={2}>
                        <Box bgcolor="#cae3e8" p={1}>
                            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                                {section.name}
                            </Typography>
                        </Box>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ fontWeight: "bold" }}>項目</TableCell>
                                    <TableCell style={{ fontWeight: "bold" }}>達成情況/規劃</TableCell>
                                    <TableCell style={{ fontWeight: "bold" }}>執行進度說明及後續規劃</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {section.columns.map((col) => (
                                    <TableRow key={col.id}>
                                        {/* 項目 */}
                                        <TableCell style={{ width: "20%" }}>{col.name}</TableCell>

                                        {/* 達成情況/規劃 */}
                                        <TableCell style={{ width: "40%" }}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                multiline
                                                // rows={5}
                                                value={formData[`${col.id}_achievement`] || ""}
                                                placeholder={col?.achievement_status_plan_description || ""}
                                                onChange={(e) =>
                                                    setFormData({
                                                        ...formData,
                                                        [`${col.id}_achievement`]: e.target.value,
                                                    })
                                                }
                                                InputProps={{
                                                    style: {
                                                        overflow: "auto",
                                                        resize: "none",
                                                        whiteSpace: "pre-wrap",
                                                    },
                                                }}
                                            />
                                        </TableCell>

                                        {/* 執行進度說明及後續規劃 */}
                                        <TableCell style={{ width: "40%" }}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                multiline
                                                value={formData[`${col.id}_implementation`] || ""}
                                                placeholder={col?.implementation_progress_description || ""}
                                                onChange={(e) =>
                                                    setFormData({
                                                        ...formData,
                                                        [`${col.id}_implementation`]: e.target.value,
                                                    })
                                                }
                                                InputProps={{
                                                    style: {
                                                        overflow: "auto",
                                                        resize: "none",
                                                        whiteSpace: "pre-wrap",
                                                    },
                                                }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                ))}
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => handleSave(1)}
                    style={{
                        backgroundColor: "#fff",
                        color: "#5597b4",
                        border: "1px solid #5597b4",
                        borderRadius: "6px",
                        marginRight: 8,
                        "&:hover": {
                            backgroundColor: "#E6F2FB",
                        },
                    }}
                >
                    暫存
                </Button>
                <Button
                    onClick={() => handleSave(2)}
                    style={{
                        backgroundColor: "#5597b4",
                        color: "#fff",
                        borderRadius: "6px",
                        marginRight: 8,
                        "&:hover": {
                            backgroundColor: "#3a7a94",
                        },
                    }}
                    variant="contained"
                >
                    完成
                </Button>
                <Button
                    onClick={onClose}
                    style={{
                        backgroundColor: "#fff",
                        color: "#555",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        "&:hover": {
                            backgroundColor: "#f5f5f5",
                        },
                    }}
                >
                    取消
                </Button>
            </DialogActions>
        </Dialog>
    );
}
